import { GET_CAREER_STATS, receiveCareerStats } from "@/components/data/ducks/Actions"
import { apiGetCareerStats } from "@/components/data/ducks/AJAX"

export default () => (next) => (action) => {
  switch (action.type) {
    case GET_CAREER_STATS:
      apiGetCareerStats(action.statType, receiveCareerStats, action.error, action.success)
      return next(action)

    default:
      return next(action)
  }
}
